import { takeLatest, put } from 'redux-saga/effects';

import {
  localEstoqueCadastro,
  NEW_LOCAL_ESTOQUE_CADASTRO,
  NEW_LOCAL_ESTOQUE_CADASTRO_SUCCESS,
} from '@handler';

function* sagaNewLocalEstoqueCadastro(action) {

  yield put({ 
    type: NEW_LOCAL_ESTOQUE_CADASTRO_SUCCESS, 
    registro: localEstoqueCadastro.newRegistro,
    isCadastroRapido: action.isCadastroRapido,
  });
}

export default function* watchNewLocalEstoqueCadastro() {
  yield takeLatest(NEW_LOCAL_ESTOQUE_CADASTRO, sagaNewLocalEstoqueCadastro)
}
